import ToolTips from './tool-tips.vue';
import { t, translateToEn, translateToEnByMessage } from '@/plugins/i18n';

export const TOOLTIP_TYPES = {
  HEAD__SUBSCRIPTION: 'HEAD__SUBSCRIPTION',
  HEAD__PAY_PER_ATTENDEE: 'HEAD__PAY_PER_ATTENDEE',
  BODY__ITEM_TITLE: 'BODY__ITEM_TITLE',
};

export default {
  name: 'WebinarExplainDialog',
  components: {
    ToolTips
  },
  props: {
    visible: Boolean,
  },
  data () {
    return {
      visibleSync: this.visible,
      TOOLTIP_TYPES,
      tableData: [
        {
          plan: this._$t('webinarSetupInWebPortal'),
          subscription: true,
          ppa: false,
        },
        {
          plan: this._$t('concurrentEvents'),
          toolTips: this._$t('coucurrentEventsToolTip'),
          subscription: false,
          ppa: true,
        },
        {
          plan: this._$t('overages'),
          subscription: false,
          ppa: true,
        },
        {
          plan: this._$t('eventsPlatformHubs'),
          isString: true,
          toolTips: this._$t('eventsHubToolTip'),
          subscription: this._$t('1HubPerLicense'),
          ppa: this._$t('1000Hubs'),
        },
        {
          plan: this._$t('eventsPlatformHosts_500AttendeesOrMore'),
          isString: true,
          toolTips: this._$t('eventsHost500'),
          subscription: this._$t('5HubHosts'),
          ppa: this._$t('100HubHosts'),
        },
        {
          plan: this._$t('eventsPlatformHosts_100Attendees'),
          isString: true,
          toolTips: this._$t('eventsHost100'),
          subscription: this._$t('2HubHosts'),
          ppa: this._$t('100HubHosts'),
        }
      ],
      search: '',
    };
  },
  watch: {
    visible(val) {
      this.visibleSync = val;
    },
  },
  methods: {
    _$t(...args) {
      return t(...args)
    },
    _$te(...args) {
      return translateToEn(...args);
    },
    _$tem(...args) {
      return translateToEnByMessage(...args);
    },
    closeDialog () {
      this.$emit('close');
    },
    mx_handleOpenTooltip(evt, type, params) {
      this.$emit('openTooltip', evt, type, params);
    }
  },
  created() {
    console.log('webinar_explain_Dialog: created')
  }
};
